export function ourOffices() {
    const $window = $(window);
    const $officeItem = $(".our-offices-item");

    $officeItem.on('click', ".our-offices-item-title", function (e) {
        if (window.innerWidth < 1024) {
            e.preventDefault();
            let $this = $(this);
            let $parent = $this.parent();
            if (!$parent.hasClass("show")) {
                $parent.addClass("show").siblings().removeClass("show").find(".our-offices-item-address , .our-offices-item-photo").slideUp(500);
                $parent.find(".our-offices-item-address , .our-offices-item-photo").slideDown(500);
            } else {
                $parent.removeClass("show").find(".our-offices-item-address , .our-offices-item-photo").slideUp(500);
            }
        }
    });
    $officeItem.on('click', ".our-offices-item-photo", function (e) {
        if (window.innerWidth >= 1024 && $("body").hasClass("touch")) {
            e.preventDefault();
            let $this = $(this);
            let $parent = $this.parent();
            $parent.siblings().removeClass("show").find(".our-offices-item-title, .our-offices-item-address, .our-offices-item-photo").removeAttr("style");
            $parent.toggleClass("show").find(".our-offices-item-title, .our-offices-item-address, .our-offices-item-photo").removeAttr("style");
        }
    });

    function ItemReverse() {
        $officeItem.each(function () {
            let $this = $(this);
            let parentLeft = $this.parent().offset().left;
            let ItemWidth = $this.innerWidth();
            let ItemLeft = parseInt($this.css("left"));
            let $windowWidth = $window.innerWidth();
            if ($windowWidth < ItemWidth + ItemLeft + parentLeft) {
                $this.addClass("reverse");
            } else  {
                $this.removeClass("reverse");
            }
        });
    }

    $window.on("load", function () {
        ItemReverse();
    });

    let resizeTimeout;
    $window.on("resize", function () {

        clearTimeout(resizeTimeout)
        resizeTimeout = setTimeout(() => {
            ItemReverse();
        }, 500)
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/ourOffices.js